import { render, staticRenderFns } from "./square.vue?vue&type=template&id=41fbc040&scoped=true"
import script from "./square.vue?vue&type=script&lang=ts"
export * from "./square.vue?vue&type=script&lang=ts"
import style0 from "./square.vue?vue&type=style&index=0&id=41fbc040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fbc040",
  null
  
)

export default component.exports